import { type TDashboardParams, DashboardService } from "@/service";
import type { IDashboard } from "@/types";
import { enableMapSet } from "immer";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

enableMapSet();

type TDashboardStore = {
   workspaceDashboardMap: Record<string, IDashboard>;
   fetchDashboard: (
      slug: string,
      query: TDashboardParams,
   ) => Promise<IDashboard>;
};

const service = new DashboardService();

export const useDashboardStore = create<TDashboardStore>()(
   immer((set) => ({
      workspaceDashboardMap: {},
      fetchDashboard: async (slug, query) => {
         const data = await service.getDashboard(slug, query);
         set((store) => {
            store.workspaceDashboardMap[slug] = data;
         });
         return data;
      },
   })),
);
